/* eslint-disable no-magic-numbers */
import React from 'react';
import { useIntl } from 'react-intl';

import Box from 'carbon-react/lib/components/box';
import RadioButton, { RadioButtonGroup, RadioButtonGroupProps } from 'carbon-react/lib/components/radio-button';

import { ForecastFormElementIds } from './types';

export type ForecastDurationProps = Omit<RadioButtonGroupProps, 'name' | 'id' | 'children'> & {
  type: 'fixedForecast' | 'rollingForecast';
};

const fixedForecastChoices = ['1', '2', '3', '4', '5', '6'];
const rollingForecastChoices = ['FY+1', 'FY+2', 'FY+3'];

const getChoiceLabel = (choice: string, intl: ReturnType<typeof useIntl>) => {
  if (choice.includes('FY+')) {
    const value = choice.replace('FY+', '');
    return intl.formatMessage(
      {
        id: 'predict.create_forecast.forecast_duration_choice_fy+x_year',
        defaultMessage: 'This FY + {value} year'
      },
      {
        value
      }
    );
  } else {
    return intl.formatMessage(
      {
        id: 'predict.create_forecast.forecast_duration_choice_year',
        defaultMessage: '{value} year'
      },
      {
        value: choice
      }
    );
  }
};

export const ForecastDuration = (props: ForecastDurationProps) => {
  const intl = useIntl();
  const choices = props.type === 'fixedForecast' ? fixedForecastChoices : rollingForecastChoices;

  return (
    <Box>
      <RadioButtonGroup name={ForecastFormElementIds.Duration} id={ForecastFormElementIds.Duration} required {...props}>
        {choices.map(choice => (
          <RadioButton
            key={choice}
            id={`forecast-duration-${choice}`}
            value={choice}
            label={getChoiceLabel(choice, intl)}
          />
        ))}
      </RadioButtonGroup>
    </Box>
  );
};
